import React, { Component} from "react";
import { withRouter, Link } from "react-router-dom";
import {Footer, Header, LastSection} from "../components";

class ContactUs extends Component{
	componentDidMount() {
		window.scrollTo(0,0);
	}
	render () {
		return(
			<div>
				<Header />
				<div className="container direction-rtl mb-5">
					<div className="row faqpage-container">
						<h1 className="pb-4 text-right faq-page-title pl-0">
							ارتباط با ما
						</h1>
						<div className="col-12 text-right faq-detail text-right">
							<div className="text-right direction-rtl">
								تلفن:&nbsp;&nbsp;<div className="list-inline-item direction-ltr text-left">۰۲۱&nbsp;&nbsp;۶۲&nbsp;&nbsp;۹۹۵&nbsp;&nbsp;۰۵۰</div>
							</div>
							<div className="text-right">
								فکس:&nbsp;&nbsp;<div className="list-inline-item direction-ltr text-left">۰۲۱&nbsp;&nbsp;۶۶&nbsp;&nbsp;۵۵۷&nbsp;&nbsp;۶۳۷</div>
							</div>
							<br/>
							<div className="text-right">پشتیبانی در تلگرام: <Link to="//t.me/MapsaAdmin" target={"_blank"}>https://t.me/MapsaAdmin</Link></div>
							<div className="text-right">کانال تلگرام: <Link to="//t.me/mapsa_ir" target={"_blank"}>https://t.me/mapsa_ir</Link></div>
							<div className="text-right">وب سایت: <Link to="//mapsa.ir" target={"_blank"}>https://mapsa.ir</Link></div>
						</div>
					</div>
				</div>
				<LastSection/>
				<Footer />
			</div>
		);
	}
}

export default withRouter(ContactUs);